<template>
    <v-layout row xs12>
      <Loading :value="loading"></Loading>
      <v-dialog v-model="dialogAjoutConducteur" max-width="100%">
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Ajouter des dépenses au projet {{ projet.libelle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeDialog()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>

            <v-layout row class="mb-2">

                <v-flex sm3 class="mr-1">
                  <v-card
                    color="red lighten-1"
                    class="white--text elevation-5"
                  >
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xs12 style=" text-align: center;">
                          <div>MONTANT DÉBIT</div>
                          <div class="display-1">
                            {{
                              new Intl.NumberFormat().format(
                                listTotals.montantD
                              )
                            }}
                            XOF
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>

                <v-flex sm3 class="mr-1">
                  <v-card
                    color="green lighten-1"
                    class="white--text elevation-5"
                  >
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xs12 style=" text-align: center;">
                          <div>MONTANT CRÉDIT</div>
                          <div class="display-1">
                            {{
                              new Intl.NumberFormat().format(
                                listTotals.montantC
                              )
                            }}
                            XOF
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
            

                <v-flex sm3 class="mr-1">
                  <v-card color="red darken-2" class="white--text elevation-5">
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xs12 style=" text-align: center;">
                          <div>SOLDE DÉBITEURS</div>
                          <div class="display-1">
                            {{
                              new Intl.NumberFormat().format(
                                listTotals.soldeD
                              )
                            }}
                            XOF
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>

                <v-flex sm3 class="mr-1">
                  <v-card color="green darken-2" class="white--text elevation-5">
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xs12 style=" text-align: center;">
                          <div>SOLDE CRÉDITEURS</div>
                          <div class="display-1">
                            {{
                              new Intl.NumberFormat().format(
                                listTotals.soldeC
                              )
                            }}
                            XOF
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>

              </v-layout>

            <v-layout row>
              <v-flex xs12>
                <data-tables :data="listeTypeTravaux" style="width: 100%">
                 
                  <el-table-column prop="date" label="Date" style="width:100%">
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.date }}
                      </v-chip>
                    </template>
                  </el-table-column>

                  <el-table-column prop="code" label="Numéro de compte" style="width:100%">
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.code }}
                      </v-chip>
                    </template>
                  </el-table-column>

                  <el-table-column prop="banque" label="Trésorerie" style="width:100%">
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.banque }}
                      </v-chip>
                    </template>
                  </el-table-column>


                  <el-table-column prop="libelle" label="Libellé écriture" style="width:100%">
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.libelle }}
                      </v-chip>
                    </template>
                  </el-table-column>
              
                  <el-table-column prop="montantD" label="Montant débit" style="width:100%">
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.montantD }}
                      </v-chip>
                    </template>
                  </el-table-column>

                  <el-table-column prop="montantC" label="Montant crédit" style="width:100%">
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.montantC }}
                      </v-chip>
                    </template>
                  </el-table-column>

                  <el-table-column prop="soldeD" label="Solde débiteur" style="width:100%">
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.soldeD }}
                      </v-chip>
                    </template>
                  </el-table-column>

                  <el-table-column prop="soldeC" label="Solde créditeur" style="width:100%">
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.soldeC }}
                      </v-chip>
                    </template>
                  </el-table-column>
<!-- 
                  <el-table-column prop="soldeC" label="Solde créditeur" style="width:100%">
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.soldeC }}
                      </v-chip>
                    </template>
                  </el-table-column> -->

                  
                  <!-- <el-table-column label="Opérations">       
                    <v-tooltip top>
                        <v-btn  slot="activator" @click.stop="edit(props.item)" fab dark small color="blue">
                          <v-icon dark>edit</v-icon>
                        </v-btn>
                        Modifier
                      </v-tooltip>

                      <v-tooltip top>
                        <v-btn  slot="activator" @click.stop="dialogSupr = true;" fab dark small color="red">
                          <v-icon dark>delete</v-icon>
                        </v-btn>
                        Supprimer
                      </v-tooltip>                                  
                    </el-table-column> -->

                </data-tables>
              </v-flex>
            </v-layout>
  
            <v-layout row>
              <v-flex xs12 class="text-xs-right">          
                <v-btn @click="closeDialog()" color="orange" dark
                  >Annuler <v-icon right>close</v-icon></v-btn
                >
                <v-btn            
                  icons
                  color="blue"
                  @click="saveListe()"
                  dark
                  >Enregistrer <v-icon right>save</v-icon></v-btn
                >
              </v-flex>

            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

        <!-- MODAL SUPPRESSION -->
        <v-dialog v-model="dialogSupr" max-width="50%" :overlay="true" scrollable persistent>
        <v-card>
          <v-card-text text-xs-center>
            <h3 align="center">Voulez-vous vraiment supprimer cette ligne ?</h3>
            <p align="center">
              <v-btn @click.native="dialogSupr = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons color="red" @click.stop="deleteRow()" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
            </p>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>



    </v-layout>    
  </template>
  
  <script>
  import Loading from "@/components/Loading";
  export default {
    name: "LoadDepenseProduitExcel",
    components: { Loading },
    props: {
      listeTypeTravaux: {
        type: Array,
        default: null
      },
      projet: {
        type: Array,
        default: null
      },
      show: {
        type: Boolean,
        default: false
      },
      idTypeProjet: {
        type: Number
      },
      listTotals: {
        type: Array,
        default: null
      }
    },
    data() {
      return {
        domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
        user: JSON.parse(sessionStorage.getItem("userInfo")),
        roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
        droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
        dialogAjoutConducteur: false,
        loading: false,
        dialogSupr: false,
        idLigne: null,

      };
    },
    watch: {
      show: function(newValue, oldValue) {
        if (newValue == true) {
          this.dialogAjoutConducteur = true;
        } else {
          this.dialogAjoutConducteur = false;
        }
      }
    },
    methods: {
      saveListe() {
        let succesEnreg = true;
        let url = this.domaine + "projet/save/depense/excel";
        let nbData = 10;
        let nbReq = 1;
        let ligne = null;
  
        let nbRest;
        if (this.listeTypeTravaux.length > 10) {
          nbData = 10;
          nbReq = Math.round(this.listeTypeTravaux.length / nbData);
          nbRest = this.listeTypeTravaux.length % nbData;
          if (nbRest > 0) {
            nbReq += 1;
          }
        }
  
        for (let i = 0; i < nbReq; i++) {
          let initJ = i * nbData;
          let finJ = (i + 1) * nbData;
          let dataLot = [];
          if (this.listeTypeTravaux.length > 0) {
            for (let j = initJ; j < finJ; j++) {
              if (this.listeTypeTravaux[j] == undefined) {
                break;
              }
              dataLot.push(this.listeTypeTravaux[j]);
            }
          }
          let data = new FormData();
  
          for (let prop in dataLot) {
            ligne = dataLot[prop];
            data.append("option[date][]", ligne.date);
            data.append("option[code][]", ligne.code);
            data.append("option[banque][]", ligne.banque);
            data.append("option[libelle][]", ligne.libelle);
            data.append("option[type][]", ligne.type);
            data.append("option[montantD][]", ligne.montantD);
            data.append("option[montantC][]", ligne.montantC);
            data.append("option[soldeD][]", ligne.soldeD);
            data.append("option[soldeC][]", ligne.soldeC);
          }
          data.append("idUser", this.user.id);
          data.append("projet", this.projet.id);
  
          this.$http.post(url, data).then(
            resp => {},
            error => {
              this.loading = false;
              this.$message.error(
                "Erreur lors de l'enregistrement des types travaux"
              );
              // succesEnreg = false;
              // window.location.reload();
            }
          );
        }
        const loading = this.$loading({
          lock: true,
          text: "Veuillez patientez ...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        setTimeout(() => {
          loading.close();
          // this.loading = false
          if (succesEnreg == true) {
            this.dialogAjoutConducteur = false;
            this.$emit("close");
            this.$emit("showModalLoadTypeTravaux");
            
  
            this.$notify({
              title: "Enregistrement",
              message: "La liste a ete enregistre avec succes",
              type: "success",
              position: "top-right",
              duration: 7000
            });
          }
        }, 30000);
      },
      edit(row) {

      },
      deleteRow(row) {       
        console.log('row',row) 
        const index = this.listeTypeTravaux.indexOf(row);
        if (index !== -1) {
            this.listeTypeTravaux.splice(index, 1); // Supprime l'élément à l'index trouvé
        }
      },
      loadTravauxParType() {
        this.loading = true;
        setTimeout(() => {
          this.listeProjetTravaux.splice(0);
          let url = this.domaine + "projet/liste/typeTravaux";
          this.$http.get(url).then(
            response => {
              this.listeProjetTravaux = response.body.listeProjetTravaux;
              this.loading = false;
            },
            error => {
              this.loading = false;
              this.$message.error("Erreur lors du chargement des travaux ");
            }
          );
        }, 2000);
      },
      closeDialog() {
        const loading = this.$loading({
          lock: true,
          text: "Veuillez patientez ...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        setTimeout(() => {
          loading.close();
          this.$emit("close");
        }, 1000);
      }
    }
  };
  </script>
  
  <style scoped></style>
  


// WEBPACK FOOTER //
// src/components/divers/LoadDepenseProduitExcel.vue